import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../constants/AppConstants';
import { Switch, Route, Redirect } from 'react-router-dom';

import Home from '../ui/home/home.jsx';
import NotFound from '../ui/NotFoundPage.jsx';
import ImpostazioniMasterPage from '../ui/impostazioni/impostazioniMasterPage.jsx'
import MenuTop from './MenuTop.jsx'
import Footer from './Footer.jsx';
import Manage from '../ui/account/manage.jsx';
import ChangePassword from '../ui/account/changePassword.jsx';
// import GruppoProdottoMasterPage from '../ui/gruppoProdotto/gruppoProdottoMasterPage.jsx'
import MicroCategorieMasterPage from '../ui/microCategorie/MicroCategorieMasterPage.jsx'
import ProdottoMasterPage from '../ui/prodotto/prodottoMasterPage.jsx'
import GaranzieMasterPage from '../ui/garanzie/garanzieMasterPage.jsx';
import BisogniMasterPage from '../ui/bisogni/bisogniMasterPage.jsx';
import CategorieMasterPage from '../ui/categorieProdotto/categorieMasterPage.jsx'
import FamiglieMasterPage from '../ui/famigliaProdotto/famiglieMasterPage.jsx'
import CompagnieMasterPage from '../ui/compagnie/compagnieMasterPage.jsx'
import FondiMasterPage from '../ui/fondi/fondiMasterPage.jsx'

class MasterPage extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MasterPage.jsx] ';
    }

    render() {
        console.log(this.componentName + "render");
        return (
            <div role="document" >

                <MenuTop />
                <div className="container-fluid" role="main">
                    <Switch>
                        <Redirect exact="true" from="/" to="/home" />

                        <Route path="/home" component={Home} />
                        <Route path="/impostazioni" component={ImpostazioniMasterPage} />
                        <Route path="/account/manage" component={Manage} />
                        <Route path="/account/changePassword" component={ChangePassword} />
                        {/* <Route path="/gruppoProdotto" component={GruppoProdottoMasterPage} /> */}
                        <Route path="/microCategorie" component={MicroCategorieMasterPage} />
                        <Route path="/prodotto" component={ProdottoMasterPage} />
                        <Route path="/garanzie" component={GaranzieMasterPage} />
                        <Route path="/bisogni" component={BisogniMasterPage} />
                        <Route path="/categorie" component={CategorieMasterPage} />
                        <Route path="/famiglie" component={FamiglieMasterPage} />
                        <Route path="/compagnie" component={CompagnieMasterPage} />
                        <Route path="/fondi" component={FondiMasterPage} />


                        <Route component={NotFound} />
                    </Switch>
                </div>
                <Footer />
            </div>
        )
    }
}


export default MasterPage;